import React, { useContext } from 'react';

import { Form, Formik } from 'formik';
import { useToasts } from 'react-toast-notifications';

import Button from '@components/common/Button/Button';
import Input from '@components/common/Formik/FormikInputField';
import useTranslateLpc from '@components/common/hooks/useTranslateLpc';
import Text from '@components/common/Text/Text';
import UserContext from '@components/lpc/Context/User/UserContext';
import AccountService from '@services/domain/Lpc/AccountService';
import { newsLetterSchema } from '@validations/userSchema';

import css from './NewsLetter.module.scss';

const NewsLetter = () => {
    const { t } = useTranslateLpc('lpc-solidarity-page');
    const { addToast } = useToasts();
    const userContext = useContext(UserContext);
    const { userAccount } = userContext;

    const getInitialValues = () => {
        return {
            email: userAccount?.email,
        };
    };

    const renderForm = (isValid: any) => {
        return (
            <Form className={css.newsletter_container__form}>
                <div className={css.newsletter_container__form__container}>
                    <Input isFloatingLabel name="email" type="text" label={t('newsletter.email_placeholder')} />
                    <Button
                        type={'submit'}
                        variant={'tertiary-muted'}
                        isDisabled={!isValid}
                        customClass={css.newsletter_container__form__btn}
                    >
                        {t('newsletter.button')}
                    </Button>
                </div>
            </Form>
        );
    };

    const subscribeToNewsLetter = async (values: any) => {
        AccountService.subscribeToNewsLetter(values)
            .then(
                (res) =>
                    res.status === 200 &&
                    addToast(t(`success.SUBSCRIBE_SUCCESS`), {
                        appearance: 'success',
                        autoDismiss: true,
                    }),
            )
            .catch((err) =>
                addToast(t(`errors.${err.code}`), {
                    appearance: 'error',
                    autoDismiss: true,
                }),
            );
    };
    return (
        <div className={css.newsletter_container}>
            <Text variant={'body_00'} color={'black-gray'} customClass={css.newsletter_container__title}>
                {t('newsletter.title')}
            </Text>
            <Text variant={'body_00'} color={'light-black-gray'} customClass={css.newsletter_container__desc}>
                {t('newsletter.description')}
            </Text>
            <Formik
                validationSchema={newsLetterSchema}
                onSubmit={(values) => subscribeToNewsLetter(values)}
                initialValues={getInitialValues()}
            >
                {({ isValid }) => renderForm(isValid)}
            </Formik>
        </div>
    );
};
export default NewsLetter;
